var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";

var SVG = function (_React$Component) {
  _inherits(SVG, _React$Component);

  function SVG() {
    _classCallCheck(this, SVG);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  SVG.prototype.render = function render() {
    return React.createElement(
      "svg",
      _extends({ width: "24", height: "24", viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, this.props),
      React.createElement(
        "title",
        null,
        "Untitled 6"
      ),
      React.createElement("path", { d: "M23.374 20.42l-4.206-4.135a10.163 10.163 0 0 0 1.84-5.835 10.205 10.205 0 0 0-3.072-7.294 10.562 10.562 0 0 0-7.42-3.02 10.56 10.56 0 0 0-7.419 3.02A10.206 10.206 0 0 0 .024 10.45c0 2.842 1.178 5.433 3.074 7.293a10.559 10.559 0 0 0 7.419 3.021c2.101.001 4.066-.613 5.71-1.662l4.244 4.171a2.076 2.076 0 0 0 2.903 0 1.993 1.993 0 0 0 0-2.853zM6.001 14.89a6.197 6.197 0 0 1-1.87-4.44A6.197 6.197 0 0 1 6 6.01a6.412 6.412 0 0 1 4.516-1.838c1.77 0 3.353.7 4.516 1.838a6.197 6.197 0 0 1 1.87 4.44c0 1.74-.711 3.297-1.87 4.44a6.411 6.411 0 0 1-4.516 1.838c-1.77 0-3.354-.7-4.516-1.839z", fill: "#232323", fillRule: "evenodd" })
    );
  };

  return SVG;
}(React.Component);

export { SVG as default };


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/icons/components/ic_search_24px.svg.react.js
// module id = null
// module chunks = 